<template>
  <sb-panel
    class="sb-purchased"
    heading="Recently purchased"
    collection="purchased"
  >
    <sb-products
      errorMessage="No previous products found!"
      :products="purchasedProducts || []"
      collection="purchased"
      :collectionPage="purchasedProductsPage"
      @toggleProducts="togglePurchased"
      @toggleSimilar="toggleSimilar"
      v-if="purchasedOpen"
    ></sb-products>
  </sb-panel>
</template>

<script>
import sbPanel from "./partials/Panel.vue";
import sbProducts from "./partials/ProductGrid.vue";
import { mapState } from "vuex";

export default {
  computed: mapState([
    "purchasedProductsPage",
    "purchasedProducts",
    "purchasedOpen",
    "uuid",
    "currencyCode",
  ]),
  props: {
    cid: { type: String },
    recentlypurchased: { type: String },
  },
  components: {
    sbPanel,
    sbProducts,
  },
  data() {
    return {};
  },
  methods: {
    togglePurchased() {
      let parsedProducts = JSON.parse(this.recentlypurchased);
      this.$store.commit("UPDATE_PURCHASED", parsedProducts);
      this.$store.commit("OPEN_PANEL", "purchased");
      this.$store.commit("TOGGLE_LOADING", false);
    },
    toggleSimilar(payload) {
      this.$store.commit("CLOSE_PANEL", "purchased");

      this.$emit("toggleSimilar", {
        sku: payload.sku,
        page: 1,
        reset: true,
        toggle: true,
      });
    },
  },
};
</script>

<style scoped>
#shopbox .sb-recent {
  min-width: 200px;
  min-height: 100px;
}
</style>
